export default __webpack_public_path__ + "static/media/p-card.56a3804e.png";